// extracted by mini-css-extract-plugin
export default {"title":"SliderQuestion_title__pi-rr","optional":"SliderQuestion_optional__G8xFC","slider":"SliderQuestion_slider__Tj3kP"};